import { clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// The marketing site's custom scale (`mk-*` in tailwind.config.js) is not in
// tailwind-merge's defaults: it would read `shadow-mk-lift` as a shadow colour
// and never let `rounded-mk-card` or `ease-mk` override their defaults. Colour
// tokens (`bg-mk-ink`, `text-mk-body`, ...) already merge correctly.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      shadow: [{ shadow: ["mk-soft", "mk-lift"] }],
      rounded: [{ rounded: ["mk-bezel", "mk-inner", "mk-card"] }],
      ease: [{ ease: ["mk"] }],
    },
  },
})

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// Depth key of a TPPMP path: everything before the first ':'. Never use
// tppmp[0] — depth keys go multi-letter ("AA", "AB", ...) past 26 depths.
export function depthFromTppmp(tppmp) {
  return String(tppmp ?? "").split(":", 1)[0]
}

/**
 * True when a property holds a value worth rendering. Unlike a plain truthiness
 * check, this treats 0 and false as real values — only null, undefined and the
 * empty string count as "no value". Use this to gate "No value set" fallbacks so
 * a number field set to 0 renders 0 instead of reading as empty.
 */
export function hasValue(value) {
  return value !== null && value !== undefined && value !== ''
}
